import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "green-room-pocket"
};
const _hoisted_2 = {
  key: 1,
  class: "props-list"
};
const _hoisted_3 = {
  class: "filter-container"
};
const _hoisted_4 = {
  key: 1,
  class: "pocket-props-list"
};
const _hoisted_5 = {
  key: 2,
  class: "pagination-container"
};
import { computed, onMounted, ref } from 'vue';
import { ElMessage, ElRow } from 'element-plus';
import { request } from '@/manager/net_manager';
import PocketPropsHeader from '@/components/Props/PocketPropsHeader.vue';
import PropsCard from '@/components/Props/PropsCard.vue';
import store from '@/store'; // pre-declaration

export default {
  __name: 'GreenRoomPocket',
  props: {
    roleId: {
      type: String,
      required: true
    },
    preparedProps: {
      type: Object,
      required: true
    }
  },
  emits: ['selected-prop'],

  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit; // refs

    const dataArray = ref([]);
    const roleProp = ref(null);
    const pagerCount = ref(5);
    const size = ref(21);
    const total = ref(0);
    const page = ref(0);
    const cacheFilterInfo = ref({});
    const propsTypes = ref([]);
    const propsTags = ref([]); // computed

    const worldOutlook = computed(() => store.state.world_outlook);
    const preparedPropsIds = computed(() => Object.keys(props.preparedProps)); // functions

    function getData(filterInfo = null) {
      roleProp.value = null;
      let parameters = {};
      parameters['role_id'] = props.roleId;
      parameters['world_outlook_id'] = worldOutlook.value.id;
      parameters['page'] = page.value;
      parameters['size'] = size.value;

      if (filterInfo) {
        cacheFilterInfo.value = filterInfo;
        Object.entries(filterInfo).forEach(item => {
          parameters[item[0]] = item[1];
        });
      } else if (Object.keys(cacheFilterInfo.value).length !== 0) {
        Object.entries(cacheFilterInfo.value).forEach(item => {
          parameters[item[0]] = item[1];
        });
      }

      request('props/role_props/list/', parameters, 'POST').then(response => {
        // console.log(JSON.stringify(response))
        if (response.code !== 0) {
          ElMessage.error({
            message: response.msg,
            duration: 1500
          });
          return;
        }

        dataArray.value = response.data.props;
        total.value = response.data.numbers; // console.log(JSON.stringify(response.data.existing_props_types), JSON.stringify(response.data.existing_props_tag))

        if (Object.keys(cacheFilterInfo.value).length === 0 && response.data.existing_props_types && response.data.existing_props_tag) {
          propsTypes.value = response.data.existing_props_types;
          propsTags.value = response.data.existing_props_tag;
        }
      });
    }

    function handlePageChange(index) {
      page.value = index - 1;
      getData();
    }

    const updateFilter = filterInfo => {
      page.value = 0;
      getData(filterInfo);
    };

    const selectedProp = item => {
      emits('selected-prop', item);
    }; // lifecycle


    onMounted(() => {
      getData();
    });
    return (_ctx, _cache) => {
      const _component_el_pagination = _resolveComponent("el-pagination");

      return __props.roleId ? (_openBlock(), _createElementBlock("div", _hoisted_1, [total.value === 0 && Object.keys(cacheFilterInfo.value).length === 0 ? (_openBlock(), _createBlock(_unref(ElRow), {
        key: 0,
        class: "empty-data-tips"
      }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [_createElementVNode("text", null, "未发现持有物数据", -1)]))]),
        _: 1
      })) : (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(PocketPropsHeader, {
        "existing-types": propsTypes.value,
        "existing-tags": propsTags.value,
        onUpdateFilter: updateFilter
      }, null, 8, ["existing-types", "existing-tags"])]), total.value === 0 && Object.keys(cacheFilterInfo.value).length !== 0 ? (_openBlock(), _createBlock(_unref(ElRow), {
        key: 0,
        class: "empty-data-tips"
      }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createElementVNode("text", null, "未发现检索数据", -1)]))]),
        _: 1
      })) : (_openBlock(), _createElementBlock("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataArray.value, (item, key) => {
        return _openBlock(), _createBlock(PropsCard, {
          key: key,
          data: item,
          "pocket-mode": true,
          "is-selected": preparedPropsIds.value.includes(item.id.toString()),
          onClick: $event => selectedProp(item)
        }, null, 8, ["data", "is-selected", "onClick"]);
      }), 128))])), total.value > size.value ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_el_pagination, {
        "page-size": size.value,
        "pager-count": pagerCount.value,
        layout: "prev, pager, next",
        total: total.value,
        background: true,
        onChange: handlePageChange
      }, null, 8, ["page-size", "pager-count", "total"])])) : _createCommentVNode("", true)]))])) : _createCommentVNode("", true);
    };
  }

};